import { Skeleton } from '@/components/ui/skeleton.component';

const COLLAPSED_CARDS = 3;

export function EntityProceduresSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-4 rounded-3xl border border-gray-300 px-3 py-6">
        <Skeleton className="h-6 w-3/4" />

        <div className="flex flex-col gap-4 rounded-2xl border border-gray-300 p-3">
          <Skeleton className="h-5 w-1/2" />
          <Skeleton className="h-32 w-full" />
          <Skeleton className="h-6 w-40" />
        </div>
      </div>

      {Array.from({ length: COLLAPSED_CARDS }).map((_, index) => (
        <div
          key={`entity-procedure-skeleton-${index}`}
          className="rounded-3xl border border-gray-300 px-3 py-6"
        >
          <Skeleton className="h-6 w-2/3" />
        </div>
      ))}
    </div>
  );
}
